/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Phone1Inputs */

const en_clients_field_phone1 = /** @type {(inputs: Clients_Field_Phone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone 1`)
};

const pt_br2_clients_field_phone1 = /** @type {(inputs: Clients_Field_Phone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone 1`)
};

/**
* | output |
* | --- |
* | "Phone 1" |
*
* @param {Clients_Field_Phone1Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_phone1 = /** @type {((inputs?: Clients_Field_Phone1Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Phone1Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_phone1(inputs)
	return pt_br2_clients_field_phone1(inputs)
});